export default "__VITE_ASSET__BsWU5ZvD__"